//**auto-generated don't edit this code**//
export enum DemographicGroup {
	None,
	LunchStatus,
	SpecialProgram,
	RaceEthnicity,
}